import MUIBox from '@/components/MUI-Components/MUI-Box';
import MUIList from '@/components/MUI-Components/MUIList';
import MUIListItem from '@/components/MUI-Components/MUIList/MUIListItem';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import React, {memo} from 'react';
import parse from 'html-react-parser';

const TimeLineListing = (props: any) => {
    const {listingContent, wrapper = true} = props;
    return listingContent?.map((item: any, index: number) => {
        return (
            <MUIBox key={`${item?.header + index}`} className={wrapper ? 'web3-content-wrapper' : ''}>
                {item?.header && (
                    <MUITypography className="web3-list-item-header" component="h6">
                        {item.header}
                    </MUITypography>
                )}
                <MUIList>
                    {item?.body?.map((subitem: any, itemIndex: number) => (
                        <MUIListItem key={itemIndex + index} className="web3-list-item web3-list-spacing">
                            <span>{subitem.heading}</span> {subitem.content ? parse(subitem.content) : ''}
                        </MUIListItem>
                    ))}
                </MUIList>
            </MUIBox>
        );
    });
};

export default memo(TimeLineListing);
